import React from 'react';
import Header4 from './../Common/Header4';
import Footer from './../Common/Footer';
import Slider1 from './../Elements/Slider1';
import About1 from './../Elements/About1';
import WhatWeDo1 from './../Elements/WhatWeDo1';
import Testimonials1 from './../Elements/Testimonials1';
import Services1 from './../Elements/Services1';
import Projects1 from './../Elements/Projects1';
import ClientsLogo1 from './../Elements/ClientsLogo1';
import Team1 from './../Elements/Team1';
import About4 from './../Elements/About4';
import Services3 from './../Elements/Services3';

class Home1 extends React.Component {
    render() {
        return (
            <>
                <Header4 />
                <div className="page-content">
                    <Slider1 />
                    <About4 />
                    <WhatWeDo1 />
                    {/* <Testimonials1 /> */}
                    <Services3 />
                    <Projects1 />
                    {/* <ClientsLogo1 />     */}
                    {/* <Team1 /> */}
                </div>
                <Footer />
            </>
        );
    };
};

export default Home1;